import React from 'react';

const TopBar = () => {
  const iconStyle = {
    width: '30px',
    height: '30px',
    objectFit: 'contain',
    marginRight: '5px',
    verticalAlign: 'middle'
  };
  
  const socialIconStyle = {
    width: '20px',
    height: '20px',
    objectFit: 'contain',
    transition: 'transform 0.3s ease'
  };
  
  const socialLinkStyle = {
    marginLeft: '15px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  
  const topBarStyle = {
    display: 'block', 
    visibility: 'visible', 
    opacity: 1, 
    backgroundColor: '#f8f9fa',
    fontFamily: '"Roboto", "Poppins", sans-serif'
  };
  
  const phoneTextStyle = {
    fontFamily: 'sans-serif', 
    fontWeight: '500', 
    fontSize: '15px'
  };

  return (
    <div className="top-bar py-2" style={topBarStyle}>
      <div className="container-fluid container-xl">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="top-contact text-start">
              <img 
                src="https://img.favpng.com/23/10/4/telephone-call-computer-icons-symbol-png-favpng-BaPihDh0pT38Bf5PJ9qjfYYNV.jpg" 
                alt="Phone" 
                style={iconStyle} 
              />
              <span style={phoneTextStyle}>
                24x7 Technical Support: +91 9953003900
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="social-icons text-end">
              <a 
                href="https://www.facebook.com/DigisoftService/" 
                className="me-2" 
                aria-label="Facebook" 
                style={socialLinkStyle}
              >
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Facebook_Logo_%282019%29.png/1024px-Facebook_Logo_%282019%29.png" 
                  alt="Facebook" 
                  style={socialIconStyle}
                  onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                />
              </a>
              <a 
                href="https://www.instagram.com/digisoft_services/" 
                className="me-2" 
                aria-label="Instagram" 
                style={socialLinkStyle}
              >
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" 
                  alt="Instagram" 
                  style={socialIconStyle}
                  onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                />
              </a>
              <a 
                href="https://www.linkedin.com/company/digisoftservices/" 
                aria-label="LinkedIn" 
                style={socialLinkStyle}
              >
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/960px-LinkedIn_logo_initials.png" 
                  alt="LinkedIn" 
                  style={socialIconStyle}
                  onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar; 